import React from 'react'
import Navbar from '../Components/Navbar';
// import { Link } from 'react-router-dom';
// import { BrowserRouter } from "react-router-dom"
// import MyButton from '../Components/MyButton'
import Footer from '../Components/Footer'

const Sayhello = () => {
  return (
    <div>
       
       
       <Navbar />
       {/* <MyButton /> */}

<h1>I am Say Hello</h1>
     
<Footer />

    </div>
  )
}

export default Sayhello